export interface MatSnackBarContentInterface {
    description: string;
    heading: string;
    class: string;
    titleClass: string;
    type: string;
    isButton: boolean;
    url: string;
}

export const defaultSuccessSnackbarConfig = {
    heading: 'Success',
    isButton: false,
    url: '',
    class: 'success-snackbar-box',
    titleClass: 'success-snackbar-txt',
    type: 'check_circle',
};

export const defaultErrorSnackbarConfig = {
    heading: 'Error',
    isButton: false,
    url: '',
    class: 'error-snackbar-box',
    titleClass: 'error-snackbar-txt',
    type: 'block',
};

export const defaultInfoSnackbarConfig = {
    heading: 'Info',
    isButton: false,
    url: '',
    class: 'info-snackbar-box',
    titleClass: 'info-snackbar-txt',
    type: 'info',
};

export const defaultWarningSnackbarConfig = {
    heading: 'Warning',
    isButton: false,
    url: '',
    class: 'warning-snackbar-box',
    titleClass: 'warning-snackbar-txt',
    type: 'warning',
};
